module.exports = __webpack_public_path__ + "static/img/thaler.debb1c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/thaler.png
// module id = wF+N
// module chunks = 0